"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IcPremiumCircular_1 = __importDefault(require("./IcPremiumCircular"));
var style_1 = require("./style");
var Premium = function (_a) {
    var link = _a.link, sentence = _a.sentence, title = _a.title;
    return (react_1.default.createElement(style_1.Wrapper, null,
        react_1.default.createElement("div", { className: 'MainSection__Column__PremiumTitle' },
            react_1.default.createElement(IcPremiumCircular_1.default, null),
            react_1.default.createElement("span", null, title)),
        react_1.default.createElement("p", { className: 'MainSection__Column__PremiumText' }, sentence),
        react_1.default.createElement("a", __assign({ className: 'MainSection__Column__PremiumLink' }, link.props), link.label)));
};
exports.default = Premium;
